import { useTranslation } from "react-i18next";
import Header from "../containers/Header";
import MainLayout from "../layouts/MainLayout";
import Footer from "../containers/Footer";
import { motion } from "framer-motion";

function About() {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Header
        caption={t("about-page_header_title")}
        bgImg={
          "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655460926/about-img-header_bu8d6m.svg"
        }
      />
      <MainLayout pageCSS="about-page">
        <h2>{t("about_page_caption_text")}</h2>
        <div className="about-container u-mb-medium">
          <div className="about-page__body-text">
            {t("about_page_body_first_text")}
          </div>
          <div className="about-page__body-text">
            {t("about_page_body_second_text")}
          </div>
          <div className="about-page__body-text">
            {t("about_page_body_third_text")}
          </div>
          <div className="about-page__body-text">
            {t("about_page_body_fourth_text")}
          </div>
          <div className="about-page__body-text">
            {t("about_page_body_fifth_text")}
          </div>
        </div>
      </MainLayout>
      <Footer />
    </motion.div>
  );
}

export default About;
